import { CustomSpinner } from '../CustomSpinner'
import { Content, LoadingText, LoadingView } from './styles'

export function ContentLoading({
  isLoading,
  loadingText,
  loadingColor,
  children,
}) {
  return (
    <>
      {isLoading ? (
        <Content>
          <LoadingView>
            <CustomSpinner
              size={40}
              color={loadingColor}
            />
            {loadingText && <LoadingText>{loadingText}</LoadingText>}
          </LoadingView>
        </Content>
      ) : (
        children
      )}
    </>
  )
}
